import type { BoxProps } from '@chakra-ui/react';

export interface BBSpinnerProps extends BoxProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  color?: string;
  trackColor?: string;
  speed?: number;
}

export const BBSpinnerDefaultProps: BBSpinnerProps = {
  size: 'md',
  color: 'red.500',
  trackColor: 'gray.800',
  speed: 1.2,
};
